<template>
  <div>
    <div
      class="block-icon-reglement-fac mr-1"
      @click.prevent.stop="adresseMail(item)"
      title="Extra Mails"
    >
      <font-awesome-icon icon="at" />
    </div>
    <!--GESTION DES EXTRA MAILS-->
    <v-dialog
      v-model="modalExtraMail"
      persistent
      max-width="1400px"
      :scrollable="true"
      :hide-overlay="true"
      no-click-animation
      content-class="custom-vuetify-dialog-list"
    >
      <v-card>
        <v-card-title class="text-h6 title-modal">
          <v-label class="label-header">GESTION DES EXTRA MAILS </v-label>
          <v-btn
            class="btn-close-header"
            icon
            @click="handleModalExtraMails('hide')"
            title="Fermer"
            color="#704ad1"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="line-hr"></v-divider>
        <v-card-text class="body-card">
          <div v-if="getLoaderMailFiliale" class="loading-block">
            <v-progress-circular
              class="ml-2"
              v-if="getLoaderMailFiliale"
              indeterminate
              color="#704ad1"
            ></v-progress-circular>
          </div>
          <div v-else class="form-add">
            <v-row>
              <v-col cols="4"></v-col>
              <v-col cols="3">
                <div
                  class="block-icon-table-facture fix-width"
                  @click.prevent.stop="addExtraFiliale()"
                  title="Ajouter un exercice"
                >
                  <font-awesome-icon icon="plus" /> Ajouter une Adresse Email
                </div>
              </v-col>
              <v-col cols="4"> </v-col>
            </v-row>
            <div
              v-for="(email, index) in getListMailFiliale"
              :key="index"
              class="card-style"
            >
              <v-row>
                <v-col cols="10">
                  <v-text-field
                    label="Adresse Email *"
                    :persistent-placeholder="true"
                    v-model="email.email"
                    outlined
                    hide-details
                    color="#704ad1"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="1" class="edit-action">
                  <div
                    class="action-icon validate mr-2"
                    @click="handleSubmitExtraMailFiliale(email, index)"
                    v-if="email.email != null || email.email != ''"
                  >
                    <font-awesome-icon
                      title="Valider Extra Mail"
                      icon="check"
                      class="fa-2x bell1 m-1"
                    />
                  </div>
                  <div
                    class="action-icon cancel mr-2"
                    @click="handleDeleteExtraMailFiliale(index, email)"
                  >
                    <font-awesome-icon
                      title="Supprimer Extra Mail"
                      icon="times"
                      class="fa-2x bell1 m-2"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
        <v-divider class="line-hr-footer"></v-divider>
        <v-card-actions class="actions-msg-btn-modal">
          <div class="error-block success-message" v-if="displayModification">
            Les modifications ont été appliquées avec succès.
          </div>
          <div
            v-if="getErrorMailFiliale"
            class="error-block message-error-modal"
          >
            <ul v-if="Array.isArray(getErrorMailFiliale)" class="mb-0">
              <li v-for="(e, index) in getErrorMailFiliale" :key="index">
                {{ e }}
              </li>
            </ul>
            <div class="message-error-modal" v-else>
              {{ getErrorMailFiliale }}
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'extra-mails',
  props: {
    item: { required: true }
  },
  data() {
    return {
      modalExtraMail: false,
      indexCheck: null,
      displayModification: false
    };
  },
  computed: {
    ...mapGetters([
      'getListMailFiliale',
      'getLoaderMailFiliale',
      'getErrorMailFiliale'
    ])
  },
  methods: {
    ...mapActions([
      'getExtraMailFiliale',
      'addExtraMailFiliale',
      'updateExtraMailFiliale',
      'deleteExtraMailFiliale',
      'resetExtraMailFiliale'
    ]),
    async handleSubmitExtraMailFiliale(email, index) {
      this.resetExtraMailFiliale();
      if (email.hasOwnProperty('id')) {
        const response = await this.updateExtraMailFiliale(email);
        if (response == true) {
          this.displayModification = true;
          setTimeout(() => {
            this.displayModification = false;
          }, 2500);
        }
      } else {
        const response = await this.addExtraMailFiliale({
          filiale_id: this.item.id,
          email: email.email
        });
        if (response == true) {
          this.getListMailFiliale.splice(index, 1);
          this.displayModification = true;
          setTimeout(() => {
            this.displayModification = false;
          }, 2500);
        }
      }
    },
    async handleDeleteExtraMailFiliale(index, email) {
      if (email.hasOwnProperty('id')) {
        const response = await this.deleteExtraMailFiliale(email.id);
        if (response == true) {
          this.displayModification = true;
          this.getListMailFiliale.splice(index, 1);
          setTimeout(() => {
            this.displayModification = false;
          }, 2500);
        }
      } else {
        this.getListMailFiliale.splice(index, 1);
      }
    },
    addExtraFiliale() {
      this.getListMailFiliale.unshift({
        email: null
      });
    },
    adresseMail(item) {
      this.getExtraMailFiliale(item.id);
      this.handleModalExtraMails('show');
    },
    handleModalExtraMails(action) {
      if (action == 'show') {
        this.modalExtraMail = true;
      } else {
        this.modalExtraMail = false;
        this.resetExtraMailFiliale();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.error-block {
  margin-left: 35%;
}
.success-message {
  color: green !important;
}
.edit-action {
  padding-top: 0px !important;
  padding-bottom: 10px !important;
  margin-top: 0 !important;
  width: 5%;
  display: flex;
  font-size: 7px;
  height: 80px;
  align-content: center;
  align-items: center;

  .action-icon {
    cursor: pointer;
  }

  .validate {
    color: green;
  }

  .cancel {
    color: #ab2525;
  }
}
.loading-block {
  margin-left: 50%;
  margin-top: 1%;
}
button.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
  color: #fff;
}
.card-style {
  border-radius: 10px;
  border: 1px solid #b5b5b5;
  padding: 28px;
  margin-top: 16px;
  margin-bottom: 20px;
}

.fix-width {
  width: 166px !important;
  padding-bottom: 23px;
  margin-left: 50%;
  padding-left: 8px;
  margin-top: 5%;
}
</style>
